dealershipModule.directive('internetQuoting', function factory() {
    return{
        templateUrl: 'app/modules/dealership/directives/internet-quoting-directive.html',
        replace: true,
        restrict: 'E',
        controller: 'InternetQuotingController'

    };
});